import React, { useState, useEffect, useRef } from 'react';
import { validatePhoneNumber } from '../utils/phoneFormatter';
import { useTranslation } from '../i18n/useTranslation';

const PhoneInput = ({
  value,
  onChange,
  placeholder = "phone number",
  disabled = false,
  className = "",
  label = "Phone number",
  showLabel = true,
  required = false,
  ...props
}) => {
  const [isValid, setIsValid] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');
  const inputRef = useRef(null);
  const t = useTranslation();

  // Update validation when value changes
  useEffect(() => {
    const validation = validatePhoneNumber(value || '');
    setIsValid(validation.valid);
    setErrorMessage(validation.errorKey ? t(validation.errorKey) : '');
  }, [value, t]);

  const handleInputChange = (event) => {
    const inputValue = event.target.value;

    // Only allow + and digits
    const sanitizedValue = inputValue.replace(/[^+\d]/g, '');

    // Validate
    const validation = validatePhoneNumber(sanitizedValue);
    setIsValid(validation.valid);
    setErrorMessage(validation.errorKey ? t(validation.errorKey) : '');

    // Call parent onChange with sanitized value
    onChange(sanitizedValue);
  };

  const handleFocus = () => {
    // Could add focus behavior here
  };

  const handleBlur = () => {
    // Final validation on blur
    const validation = validatePhoneNumber(value || '');
    setIsValid(validation.valid);
    setErrorMessage(validation.errorKey ? t(validation.errorKey) : '');
  };

  const baseClassName = "block w-full pt-2 px-3 pb-3 text-gray-700 border rounded-lg focus:outline-none";
  const stateClassName = disabled
    ? "bg-gray-200 cursor-not-allowed border-gray-300"
    : isValid
      ? "bg-white border-gray-300 focus:border-gray-500"
      : "bg-red-50 border-red-500 focus:border-red-500";

  return (
    <div className="mb-4">
      {showLabel && (
        <label className="block mb-2 text-sm text-gray-900 pb-2">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <input
        ref={inputRef}
        type="text"
        className={`${baseClassName} ${stateClassName} ${className}`}
        value={value || ''}
        onChange={handleInputChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        disabled={disabled}
        {...props}
      />
      {errorMessage && (
        <p className="text-red-500 text-xs mt-1">{errorMessage}</p>
      )}
    </div>
  );
};

export default PhoneInput;
